var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-col w-full"},[_c('h4',[_vm._v("Lista de estudiantes")]),_vm._v("\n    "+_vm._s(_vm.enviar_datos)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }